import {
  addAdminUser,
  addCustomerServiceUser,
  delEmployee,
  delCustomerServiceUser,
  editAdminInfos,
  getAdminInfo,
  getEmployeeList,
  getCustomerServiceUserInfo,
  editCustomerServiceUserInfos,
} from '../../services/employeeapi'

export default {
  state: {},
  getters: {},
  mutations: {},
  actions: {
    getEmployeeList (store, params) {
      return getEmployeeList(params)
    },
    addAdminUser (store, params) {
      return addAdminUser(params)
    },
    getAdminInfo (store, id) {
      return getAdminInfo(id)
    },
    getCustomerServiceUserInfo (store, id) {
      return getCustomerServiceUserInfo(id)
    },
    delEmployee (store, params) {
      return delEmployee(params)
    },
    delCustomerServiceUser (store, params) {
      return delCustomerServiceUser(params)
    },
    editAdminInfo (store, {id, params}) {
      return editAdminInfos(id, params)
    },
    editCustomerServiceUserInfo (store, {id, params}) {
      return editCustomerServiceUserInfos(id, params)
    },

    addCustomerServiceUser (store, params) {
      return addCustomerServiceUser(params)
    },
  }
}
